import { Component, EventEmitter } from '@angular/core';
import { Logo } from './scripts/load-logo.script';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private logo: Logo) { }

  ngOnInit(): void {
    //this.logo.load('orochi');
  }
  config = {
    topbar: {
      title: 'ANI.RYU'
    }
  }
}
